import { GridContainer } from 'libs/ui';
import { Tariff } from 'grids/tariff/tariff';

const TariffWrapper = (props) => {
  return (
    <GridContainer>
      <Tariff {...props} />
    </GridContainer>
  );
};

export default TariffWrapper;
